import React from "react";

function Header() {
  return (
    <header>
      <nav className="container">
        <div className="logo">Anshu Raj</div>
        <ul className="nav-links">
          <li><a href="#home">Home</a></li>
          <li><a href="#about">About</a></li>
          <li><a href="#skills">Skills</a></li>
          <li><a href="#projects">Projects</a></li>
          <li><a href="#achievements">Achievements</a></li>
          <li><a href="#education">Education</a></li>
          <li><a href="#experience">Experience</a></li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;
